import { useState, useEffect } from "react";
// import "../src/assets/components/listalluser.css";
import "../src/assets/components/global.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import AutoLogout from "./autologout";
import Swal from "sweetalert2";

function Newuser() {
  const [adminData, setAdminData] = useState(null);
  const [editData, setEditData] = useState(null);
  const [firstname, setFirstname] = useState("");
  const [middlename, setMiddlename] = useState("");
  const [lastname, setLastname] = useState("");
  const [age, setAge] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [gender, setGender] = useState("");
  const [cellnumber, setcellnumber] = useState("");
  const [civilstatus, setCivilstatus] = useState("Single");
  const [religion, setReligion] = useState("N/A");
  const [nationality, setNationality] = useState("");
  const [occupation, setOccupation] = useState("");
  const [recentaddress, setRecentaddress] = useState("");
  const [presentaddress, setPresentaddress] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("member"); // Default role is "member"
  const [selectedBrgyId, setSelectedBrgyId] = useState(null);

  const navigate = useNavigate();
  const [isEditVisible, setIsEditVisible] = useState(false);
  const [isSearchboxVisible, setSearchboxVisible] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  useEffect(() => {
    axios
      .get(`https://brgytracerappserver.onrender.com/newuser`, {
        params: {
          firstname,
        },
      })
      .then((res) => {
        setAdminData(res.data);
      })
      .catch((err) => console.log(err));
  }, [firstname]);

  const handleEdit = (userData) => {
    setIsEditVisible(!isEditVisible);
    setSearchboxVisible(!isSearchboxVisible);
    setEditData(userData);
    setSelectedBrgyId(userData.brgyId);
    setUsername(userData.username);
    setEmail(userData.email);
    setPassword(userData.password);
    setRole(userData.role);
    setFirstname(userData.firstname);
    setMiddlename(userData.middlename);
    setLastname(userData.lastname);
    setAge(userData.age);
    setBirthdate(userData.birthdate);
    setGender(userData.gender);
    setcellnumber(userData.cellnumber);
    setCivilstatus(userData.civilstatus);
    setReligion(userData.religion);
    setNationality(userData.nationality);
    setOccupation(userData.occupation);
    setRecentaddress(userData.recentaddress);
    setPresentaddress(userData.presentaddress);
  };

  const handlesave = async (event) => {
    event.preventDefault();
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "this user can be vulnerable to the system",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Confirm it!",
    });
    if (result.isConfirmed) {
      const updatedUserData = {
        brgyId: selectedBrgyId,
        status: "active", // Assuming you want to set the active status to "active"
      };

      try {
        const response = await axios.put(
          `https://brgytracerappserver.onrender.com/newuser/${selectedBrgyId}`,
          updatedUserData
        );
        if (response.data.status === "success") {
          await Swal.fire({
            title: "Added new User!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
          window.location.reload();
        }

        // Reload the page after a successful update
        window.location.reload();
        setIsEditVisible(false);
      } catch (error) {
        console.error("Error updating data:", error);
        alert("Error updating data: " + error.message);
      }
    }
  };

  const handleDecline = async (brgyId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, decline it!",
    });

    if (result.isConfirmed) {
      const updatedUserData = {
        brgyId: selectedBrgyId,
        status: "declined",
      };

      try {
        const response = await axios.put(
          `https://brgytracerappserver.onrender.com/newuser/${brgyId}`,
          updatedUserData
        );
        if (response.data.status === "success") {
          await Swal.fire({
            title: "Declined Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
          window.location.reload();
        }
      } catch (error) {
        console.error("Error updating data:", error);
        alert("Error updating data: " + error.message);
      }
    }
  };

  const handleSearchInputChange = (e) => {
    setFirstname(e.target.value);
  };
  const handleCancel = (e) => {
    setIsEditVisible(false);
    setFirstname("");
  };
  const handleClose = (e) => {
    navigate("/adminpage");
  };
  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      Math.min(prevPage + 1, Math.ceil(adminData.users.length / rowsPerPage))
    );
  };

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentUsers =
    adminData && adminData.users && adminData.users.slice(startIndex, endIndex);

  return (
    <div className="listalluser-parent parent-height">
      <AutoLogout />
      <div className="container">
        <div className={`searchbox ${isEditVisible ? "edit-mode" : ""}`}>
          <div>
            <FontAwesomeIcon icon={faSearch} />
            <input
              type="text"
              placeholder="Search by FirstName"
              value={firstname}
              onChange={handleSearchInputChange}
            />
          </div>
        </div>
        <div className={`datagrid-parent ${isEditVisible ? "edit-mode" : ""}`}>
          <button className="closebtn" type="button" onClick={handleClose}>
            X
          </button>
          <h1>List of New Users</h1>
          {currentUsers && currentUsers.length > 0 && (
            <div className="datagrid-holder">
              <table>
                <thead>
                  <tr>
                    <th>BrgyId</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.map((user) => (
                    <tr key={user.brgyId}>
                      <td>{user.brgyId}</td>
                      <td>{user.firstname}</td>
                      <td>{user.lastname}</td>
                      <td>{user.email}</td>
                      <td>{user.role}</td>
                      <td
                        className="handleEdit"
                        onClick={() => handleEdit(user)}>
                        View
                      </td>
                      <td
                        className="handleDelete"
                        onClick={() => handleDecline(user.brgyId)}>
                        Decline
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="pagination-controls">
                <button
                  className="pagination-button"
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}>
                  Previous
                </button>
                <span className="pagination-info">
                  Page {currentPage} of{" "}
                  {Math.ceil(adminData.users.length / rowsPerPage)}
                </span>
                <button
                  className="pagination-button"
                  onClick={handleNextPage}
                  disabled={
                    currentPage ===
                    Math.ceil(adminData.users.length / rowsPerPage)
                  }>
                  Next
                </button>
              </div>
              <button
                className="closebtn"
                type="button"
                onClick={() => handleClose()}>
                X
              </button>
            </div>
          )}
          {currentUsers && currentUsers.length === 0 && (
            <p className="noUsertext">No users available for display.</p>
          )}
        </div>
      </div>
      {/* Edit form */}
      {isEditVisible && editData && (
        <div className="Updateform-parent wrap parentof-responsive">
          <div className="updateform-holder forresponsive">
            <h1>Update form</h1>
            <div className="autonumbers">
              <label>BrgyId:{selectedBrgyId}</label>
            </div>
            <form className="formUpdate-boxcontainers" onSubmit={handlesave}>
              {/* fetch the phto in here */}
              <div className="photo-container">
                {editData.photo && (
                  <img src={editData.photo} alt="User Photo" />
                )}
              </div>
              <label>Account Information</label>
              <div className="accountbox-container">
                <div>
                  <label htmlFor="username">Username:</label>
                  <input
                    type="text"
                    placeholder="Enter Username"
                    required
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div>
                  <label>Email:</label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="password">Password:</label>
                  <input
                    type="password"
                    placeholder="Enter Password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div>
                  <label>Role:</label>
                  <select
                    value={role}
                    onChange={(e) => setRole(e.target.value)}>
                    <option value="member">Member</option>
                    <option value="officer">Officer</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
              </div>
              <label>User Information</label>
              <div className="userinfo-container">
                <div>
                  <label htmlFor="firstname">First name:</label>
                  <input
                    type="text"
                    placeholder="Enter Firstname"
                    required
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="middlename">Middle Name:</label>
                  <input
                    type="text"
                    placeholder="Enter Middle Name"
                    required
                    value={middlename}
                    onChange={(e) => setMiddlename(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="lastname">Last Name:</label>
                  <input
                    type="text"
                    placeholder="Enter Family Name"
                    required
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="age">Age:</label>
                  <input
                    type="text"
                    placeholder="Enter Age"
                    required
                    value={age}
                    min="0" // Specify minimum age
                    maxLength={3} // Set the maximum length to 3
                    pattern="[0-9]*" // Allow only numeric values
                    onKeyPress={(e) => {
                      // Allow only numeric characters and the Enter key
                      if (isNaN(e.key) && e.key !== "Enter") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      // Remove non-numeric characters
                      const numericValue = e.target.value.replace(
                        /[^0-9]/g,
                        ""
                      );

                      // Update the state with the numeric value
                      setAge(numericValue);
                    }}
                  />
                </div>
                <div>
                  <label htmlFor="Birth-Date">Birth Date:</label>
                  <input
                    type="date"
                    placeholder="Enter Birth-Date"
                    required
                    value={birthdate}
                    onChange={(e) => setBirthdate(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="Gender">Gender:</label>
                  <select
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}>
                    <option value="Not Set">Not Set</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="cellnumberNumber">Contant Number:</label>
                  <input
                    type="text"
                    placeholder="Enter cellnumber Number"
                    required
                    pattern="[0-9]{4} [0-9]{3} [0-9]{4}"
                    value={cellnumber}
                    onChange={(e) => {
                      const formattedValue = e.target.value.replace(
                        /[^0-9 ]/g,
                        ""
                      );

                      // Update the state with the formatted value
                      setcellnumber(formattedValue);
                    }}
                  />
                  <small>Format: 0000 000 0000</small>
                </div>
                <div>
                  <label htmlFor="civilstatus">Civil Status:</label>
                  <select
                    value={civilstatus}
                    onChange={(e) => setCivilstatus(e.target.value)}>
                    <option value="Single">Single</option>
                    <option value="Separated">Separated</option>
                    <option value="Married">Married</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="religion">Religion:</label>
                  <select
                    value={religion}
                    onChange={(e) => setReligion(e.target.value)}>
                    <option value="N/A">N/A</option>
                    <option value="Roman Catholic">Roman Catholic</option>
                    <option value="INC">INC</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="Nationality">Nationality:</label>
                  <select
                    value={nationality}
                    onChange={(e) => setNationality(e.target.value)}>
                    <option value="Not Set">Not Set</option>
                    <option value="Filipino">Filipino</option>
                    <option value="US">US</option>
                    <option value="INDIA">INDIA</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="occupation">Occupation:</label>
                  <select
                    value={occupation}
                    onChange={(e) => setOccupation(e.target.value)}>
                    <option value="None">None</option>
                    <option value="Labor">Labor</option>
                    <option value="Farmer">Farmer</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="recentaddress">Recentaddress:</label>
                  <input
                    type="text"
                    value={recentaddress}
                    required
                    onChange={(e) => setRecentaddress(e.target.value)}
                  />
                </div>
                <div>
                  <label htmlFor="presentaddress">Presentaddress:</label>
                  <input
                    type="text"
                    required
                    value={presentaddress}
                    onChange={(e) => setPresentaddress(e.target.value)}
                  />
                </div>
              </div>
              <span className="btn-container">
                <button className="updatebtn" type="submit">
                  Confirmed Newuser
                </button>
                <button
                  className="closebtn"
                  type="button"
                  onClick={() => handleCancel()}>
                  X
                </button>
              </span>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Newuser;
